import CustomLayoutModal from './CustomLayoutModal.container'

export default CustomLayoutModal
